import { Box, Stack, Typography } from "@mui/material";

interface NoDeploymentStateProps {
  mainText: string;
  secondaryText: string;
}

export default function NoDeploymentState({
  mainText,
  secondaryText,
}: NoDeploymentStateProps): JSX.Element {
  return (
    <Stack
      sx={{
        padding: "32px 32px 32px 32px",
        height: window.innerHeight - 325,
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Stack
        sx={{ padding: "16px 0px 16px 0px", width: "500px" }}
        justifyContent="center"
        alignItems="center"
        gap={3}
      >
        <Box
          id="no-deployment"
          component="img"
          alt="No deployment"
          src="no-deployment.png"
          sx={{ height: "169px" }}
        />
        <Stack gap={1.5} px={2} justifyContent="center" alignItems="center">
          <Typography variant="subtitle1" textAlign="center">
            {mainText}
          </Typography>
          <Typography
            variant="body2"
            textAlign="center"
            sx={{ width: "360px" }}
          >
            {secondaryText}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
